import React from 'react';
import PropTypes from 'prop-types';

import BtnSelect from '../Buttons/BtnSelect';
const SelectBtnsStyle = ({ children, setValue, value, dropStyle }) => {
    return (
        <>
            {children.map(option =>
                <BtnSelect key={option.props.value}
                    checked={value === option.props.value}
                    onClick={() => setValue(option.props.value)}
                    dropStyle={dropStyle} >
                    {option.props.children}
                </BtnSelect>)}
        </>
    )
}

SelectBtnsStyle.propTypes = {
    setValue: PropTypes.func,
    dropStyle: PropTypes.object,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number]),
    children: PropTypes.array
}

export default SelectBtnsStyle;
